module.exports = __webpack_public_path__ + "img/DAVID_CANNON_14-rs.a4b22d0c.jpg";